import { inject, Injectable } from '@angular/core';
import { StartWithUnit } from '@core/state/operators/start-with-unit';
import { Observable } from 'rxjs';
import { CustomRxState } from '@core/state/rx.state';
import { RouteForRoute } from '@api/models/BoLanka/Contract/route-for-route';
import { RoutesService } from '@api/services';
import { ServiceForRoute } from '@api/models/BoLanka/Contract/service-for-route';


interface ICommonEntitiesState {
    loading: Record<StartWithUnit, boolean>;
    routes: RouteForRoute[];
    servicesForRoute: ServiceForRoute[];
}

@Injectable()
export class CommonEntitiesState extends CustomRxState<ICommonEntitiesState> {
    readonly #routesService: RoutesService = inject(RoutesService);

    public readonly routes$: Observable<RouteForRoute[]> = this.selectLazy('routes', this.requestRoutes);
    public readonly servicesForRoute$: Observable<ServiceForRoute[]> = this.selectLazy('servicesForRoute', this.requestServicesForRoute);

    private requestRoutes(): Observable<RouteForRoute[]> {
        return this.#routesService.apiRoutesRoutesGet();
    }

    private requestServicesForRoute(): Observable<ServiceForRoute[]> {
        return this.#routesService.apiRoutesListServicesForRouteGet();
    }

}
